import { z } from "zod";
import { createListBoxSchema } from "./common";

export const preferencesSchema = z
  .object({
    outreach: createListBoxSchema<string>().optional(),
    outreachOthers: z.string().optional(),
    currentSolution: createListBoxSchema<string>().optional(),
    currentSolutionOthers: z.string().optional(),
    keyChallenges: createListBoxSchema<string>().optional(),
    keyChallengesOthers: z.string().optional(),
    teamSize: createListBoxSchema<string>().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.outreach) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["outreach"],
        message: "How did you hear about us? is required",
      });
    }

    if (!data.currentSolution) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["currentSolution"],
        message: "Current Solution is required",
      });
    }

    if (!data.keyChallenges) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["keyChallenges"],
        message: "Key Challenges is required",
      });
    }

    if (!data.teamSize) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["teamSize"],
        message: "Team Size is required",
      });
    }

    if (data.outreach?.value === "Others" && !data.outreachOthers?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["outreachOthers"],
        message: "Please specify how you heard about us",
      });
    }

    if (
      data.currentSolution?.value === "Others" &&
      !data.currentSolutionOthers?.trim()
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["currentSolutionOthers"],
        message: "Please specify your current solution",
      });
    }

    if (
      data.keyChallenges?.value === "Others" &&
      !data.keyChallengesOthers?.trim()
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["keyChallengesOthers"],
        message: "Please specify your key challenges",
      });
    }
  });

export type PreferencesFormData = z.infer<typeof preferencesSchema>;
